export const BREAKPOINTS = {
  phone: 600,
  tablet: 950,
  laptop: 1300,
}

export const QUERIES = {
  phoneAndSmaller: `(max-width: ${BREAKPOINTS.phone / 16}rem)`,
  tabletAndSmaller: `(max-width: ${BREAKPOINTS.tablet / 16}rem)`,
  laptopAndSmaller: `(max-width: ${BREAKPOINTS.laptop / 16}rem)`,
  phoneAndUp: `(min-width: ${BREAKPOINTS.phone / 16}rem)`,
  tabletAndUp: `(min-width: ${BREAKPOINTS.tablet / 16}rem)`,
  laptopAndUp: `(min-width: ${BREAKPOINTS.laptop / 16}rem)`,
} as const

export const themeObj = {
  colors: {
    // ai generated color names TODO: are these good names?
    DeepSeaBlue: 'rgba(19, 48, 64, 1)',
    OceanBlue: 'rgba(13, 93, 144, 1)',
    SkyBlue: 'rgba(0, 158, 255, 1)',
    LightSkyBlue: 'rgba(68, 187, 255, 1)',
    Teal: 'rgba(0, 105, 105, 1)',
    Turquoise: 'rgba(0, 136, 136, 1)',
    SeaGreen: 'rgba(0, 194, 144, 1)',
    MintGreen: 'rgba(87, 231, 178, 1)',
    LimeGreen: 'rgba(105, 255, 66, 1)',
    LemonYellow: 'rgba(238, 255, 0, 1)',
    Tangerine: 'rgba(255, 170, 0, 1)',
    BrightOrange: 'rgba(255, 96, 0, 1)',
    Vermilion: 'rgba(255, 48, 0, 1)',
    DeepRed: 'rgba(153, 0, 0, 1)',

    grayscale: {
      /* Pure White */
      '100': 'rgba(255, 255, 255, 1)',
      '200': 'rgba(238, 238, 238, 1)',
      '250': 'rgba(230, 230, 230, 1)' /* gray-90 */,
      '300': 'rgba(204, 204, 204, 1)' /* gray-80 */,
      '400': 'rgba(153, 153, 153, 1)' /* gray-60 */,
      '500': 'rgba(102, 102, 102, 1)' /* gray-40 */,
      '600': 'rgba(51, 51, 51, 1)',
      '700': 'rgba(17, 17, 17, 1)',
      /* Black */
      '800': 'rgba(0, 0, 0, 1)',
    },
    grayscale_alternate: {
      '100': 'rgba(34, 34, 34, 1)',
      '200': 'rgba(68, 68, 68, 1)',
    },
    highVis: 'rgba(238, 255, 0, 1)',
    // other names for brand colors
    alternate: {
      '100': 'rgba(68, 187, 255, 1)',
      '200': 'rgba(0, 158, 255, 1)',
      '400': 'rgba(13, 93, 144, 1)',
      '600': 'rgba(19, 48, 64, 1)',
    },
    average: {
      '100': 'rgba(87, 231, 178, 1)',
      '200': 'rgba(0, 194, 144, 1)',
      '400': 'rgba(0, 136, 136, 1)',
      '600': 'rgba(0, 105, 105, 1)',
    },
    attention: {
      '100': 'rgba(238, 255, 0, 1)',
      '300': 'rgba(105, 255, 66, 1)',
      '600': 'rgba(255, 170, 0, 1)',
    },

    alarm: {
      '100': 'rgba(255, 96, 0, 1)',
      '400': 'rgba(255, 48, 0, 1)',
      '600': 'rgba(153, 0, 0, 1)',
    },
    ////////////////////////////
    alert: {
      '100': 'rgba(255, 220, 195, 1)',
      '200': 'rgba(255, 183, 131, 1)',
      '300': 'rgba(255, 143, 63, 1)',
      '500': 'rgba(181, 76, 0, 1)',
      '600': 'rgba(136, 57, 0, 1)',
      '700': 'rgba(140, 42, 29, 1)',
      '400_base': 'rgba(255, 111, 7, 1)',
    },
    warning: {
      '200': 'rgba(255, 237, 155, 1)',
      '300': 'rgba(255, 214, 91, 1)',
      '500': 'rgba(183, 129, 3, 1)',
      '550': 'rgba(151, 124, 64, 1)',
      '600': 'rgba(140, 98, 0, 1)',
      '400_base': 'rgba(255, 193, 7, 1)',
    },
    success: {
      '100': 'rgba(236, 255, 233, 1)',
      '200': 'rgba(193, 247, 183, 1)',
      '300': 'rgba(128, 204, 137, 1)',
      '450': 'rgba(62, 131, 52, 1)',
      '500': 'rgba(20, 106, 54, 1)',
      '600': 'rgba(13, 65, 33, 1)',
      '400_base': 'rgba(64, 183, 78, 1)',
    },
    error: {
      '200': 'rgba(255, 219, 208, 1)',
      '300': 'rgba(255, 175, 157, 1)',
      '500': 'rgba(175, 27, 41, 1)',
      '600': 'rgba(149, 4, 17, 1)',
      '400_base': 'rgba(220, 26, 12, 1)',
    },
    blue: {
      '100': 'rgba(231, 244, 249, 1)',
      '200': 'rgba(207, 242, 255, 1)',
      '300': 'rgba(159, 225, 255, 1)',
      '400': 'rgba(15, 143, 255, 1)',
      '600': 'rgba(4, 58, 147, 1)',
      '700': 'rgba(1, 45, 117, 1)',
      '800': 'rgba(0, 29, 77, 1)',
      '500_base': 'rgba(10, 111, 219, 1)',
    },
    purple: {
      '200': 'rgba(227, 223, 251, 1)',
      '300': 'rgba(164, 156, 231, 1)',
      '400': 'rgba(132, 123, 208, 1)',
      '600': 'rgba(47, 40, 127, 1)',
      '700': 'rgba(30, 25, 102, 1)',
      '800': 'rgba(19, 15, 84, 1)',
      '500_base': 'rgba(90, 81, 177, 1)',
    },
    crimson: {
      '200': 'rgba(255, 164, 180, 1)',
      '300': 'rgba(255, 100, 128, 1)',
      '400': 'rgba(229, 61, 102, 1)',
      '600': 'rgba(167, 0, 43, 1)',
      '700': 'rgba(132, 0, 34, 1)',
      '800': 'rgba(101, 0, 26, 1)',
      '500_base': 'rgba(194, 0, 50, 1)',
    },
    yellow: {
      '100': 'rgba(255, 250, 230, 1)',
      '200': 'rgba(255, 245, 180, 1)',
      '300': 'rgba(255, 236, 130, 1)',
      '400': 'rgba(255, 223, 77, 1)',
      '600': 'rgba(204, 158, 0, 1)',
      '700': 'rgba(153, 117, 0, 1)',
      '800': 'rgba(102, 77, 0, 1)',
      '500_base': 'rgba(255, 210, 40, 1)',
    },
    gold: {
      '100': 'rgba(255, 248, 230, 1)',
      '200': 'rgba(255, 236, 184, 1)',
      '300': 'rgba(255, 215, 128, 1)',
      '400': 'rgba(255, 196, 64, 1)',
      '600': 'rgba(184, 134, 11, 1)',
      '700': 'rgba(153, 101, 21, 1)',
      '800': 'rgba(102, 68, 14, 1)',
      '500_base': 'rgba(212, 175, 55, 1)',
    },
    green: {
      '100': 'rgba(230, 249, 237, 1)',
      '200': 'rgba(186, 242, 207, 1)',
      '300': 'rgba(134, 225, 169, 1)',
      '400': 'rgba(76, 201, 124, 1)',
      '600': 'rgba(28, 128, 68, 1)',
      '700': 'rgba(21, 102, 54, 1)',
      '800': 'rgba(12, 66, 35, 1)',
      '500_base': 'rgba(56, 176, 96, 1)',
    },
    slate: {
      '200': 'rgba(241, 245, 246, 1)',
      '300': 'rgba(209, 222, 227, 1)',
      '400': 'rgba(162, 186, 195, 1)',
      '500': 'rgba(127, 148, 156, 1)',
      '600': 'rgba(81, 100, 108, 1)',
      '800': 'rgba(19, 48, 64, 1)',
      '900': 'rgba(11, 33, 45, 1)',
      '700_base': 'rgba(40, 61, 77, 1)',
    },
    gray: {
      '300': 'rgba(245, 245, 245, 1)',
      '400': 'rgba(238, 238, 238, 1)',
      '600': 'rgba(158, 158, 158, 1)',
      '700': 'rgba(114, 114, 114, 1)',
      '800': 'rgba(63, 63, 63, 1)',
      '500_base': 'rgba(224, 224, 224, 1)',
      '200_white': 'rgba(255, 255, 255, 1)',
    },
    gecko_brand: {
      '100': 'rgba(236, 255, 244, 1)',
      '200': 'rgba(200, 251, 221, 1)',
      '300': 'rgba(86, 231, 179, 1)',
      '400': 'rgba(0, 194, 144, 1)',
      '500': 'rgba(0, 134, 119, 1)',
      '700': 'rgba(19, 48, 64, 1)',
      '800': 'rgba(11, 33, 45, 1)',
      '600_base': 'rgba(0, 105, 103, 1)',
      existing: 'rgba(96, 158, 47, 1)',
    },
    cantilever_admin: {
      pageBgPrimary: 'rgba(44, 44, 44)',
      appBgPrimary: 'rgba(63, 63, 63, 1)',
      appBgSecondary: 'rgba(50, 50, 50, 1)',
      textGrayLight: 'rgba(245, 245, 245, 1)',
      textSecondary: 'rgba(158, 158, 158, 1)',
      textDisabled: 'rgba(114, 114, 114, 1)',
      textBlue: 'rgba(207, 242, 255, 1)',
      textWarning: 'rgba(255, 237, 155, 1)',
      buttonText: 'rgba(255, 255, 255, 1)',
      buttonBgBlue: 'rgba(159, 225, 255, 1)',
      buttonBgWarning: 'rgba(255, 237, 155, 0.10)',
      buttonBgError: 'rgba(255, 235, 238, 1)',
      noAccessYellow: 'rgb(252, 238, 165)',
      textGrayLightLowOpacity: 'rgba(245, 245, 245, 0.1)',
      noAccessYellowLowOpacity: 'rgb(252, 238, 165, 0.1)',
      adminBlueLowOpacity: 'rgba(207, 242, 255, 0.1)',
      hoverGrayBackground: 'rgb(78, 78, 78)',
      primaryButtonBackground: 'rgba(255, 255, 255, 0.9)',
      primaryButtonBackgroundHover: 'rgba(255, 255, 255, 0.85)',
      primaryButtonBackgroundActive: 'rgba(255, 255, 255, 0.8)',
      primaryButtonBackgroundDisabled: 'rgba(255, 255, 255, 0.05)',
      secondaryButtonBackground: 'rgba(255, 255, 255, 0.25)',
      secondaryButtonBackgroundHover: 'rgba(255, 255, 255, 0.3)',
      secondaryButtonBackgroundActive: 'rgba(255, 255, 255, 0.35)',
      dropdownContentBackground: 'rgb(34, 34, 34)',
      dialogBackgroundOverlay: 'rgba(0, 0, 0, 0.5)',
    },
    nest: {
      blue: 'rgba(241, 243, 255, 1)',
      neutral: 'rgba(236, 239, 241, 1)',
      red: 'rgba(249, 72, 60, 1)',
      green: 'rgba(231, 245, 233, 1)',
      yellow: 'rgba(162, 111, 59, 1)',
    },
  },
  fontStyles: {
    caption: {
      regular: {
        value: {
          fontSize: '0.75rem',
          fontSizePx: '12px',
          fontFamily: 'Manrope',
          fontWeight: 'Medium',
          letterSpacing: '0px',
          lineHeight: '125%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
      technical: {
        value: {
          fontSize: '0.75rem',
          fontSizePx: '12px',
          fontFamily: 'Share Tech Mono',
          fontWeight: 'Regular',
          letterSpacing: '1px',
          lineHeight: '125%',
          textIndent: '0px',
          textTransform: 'uppercase',
        },
      },
    },
    label: {
      regular: {
        value: {
          fontSize: '0.875rem',
          fontSizePx: '14px',
          fontFamily: 'Manrope',
          fontWeight: 'Regular',
          letterSpacing: '0px',
          lineHeight: '125%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
      semi_bold: {
        value: {
          fontSize: '0.875rem',
          fontSizePx: '14px',
          fontFamily: 'Manrope',
          fontWeight: 'SemiBold',
          letterSpacing: '0px',
          lineHeight: '125%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
    },
    header: {
      header_h1: {
        value: {
          fontSize: '3.5rem',
          fontSizePx: '56px',
          fontFamily: 'Manrope',
          fontWeight: 'SemiBold',
          letterSpacing: '-1px',
          lineHeight: '125%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
      header_h2: {
        value: {
          fontSize: '2.5rem',
          fontSizePx: '40px',
          fontFamily: 'Manrope',
          fontWeight: 'SemiBold',
          letterSpacing: '0px',
          lineHeight: '125%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
      header_h3: {
        value: {
          fontSize: '2rem',
          fontSizePx: '32px',
          fontFamily: 'Manrope',
          fontWeight: 'Medium',
          letterSpacing: '0px',
          lineHeight: '120%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
      header_h4: {
        value: {
          fontSize: '1.5rem',
          fontSizePx: '24px',
          fontFamily: 'Manrope',
          fontWeight: 'Medium',
          letterSpacing: '0px',
          lineHeight: '120%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
      header_h5: {
        value: {
          fontSize: '1rem',
          fontSizePx: '16px',
          fontFamily: 'Share Tech Mono',
          fontWeight: 'Regular',
          letterSpacing: '1px',
          lineHeight: '120%',
          textIndent: '0px',
          textTransform: 'uppercase',
        },
      },
      header_h6: {
        value: {
          fontSize: '0.75rem',
          fontSizePx: '12px',
          fontFamily: 'Manrope',
          fontWeight: 'Bold',
          letterSpacing: '1px',
          lineHeight: '120%',
          textIndent: '0px',
          textTransform: 'uppercase',
        },
      },
      header_h6_alt: {
        value: {
          fontSize: '1rem',
          fontSizePx: '16px',
          fontFamily: 'Manrope',
          fontWeight: 'Bold',
          letterSpacing: '1px',
          lineHeight: '120%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
    },
    body: {
      regular: {
        value: {
          fontSize: '0.875rem',
          fontSizePx: '14px',
          fontFamily: 'Manrope',
          fontWeight: 'Regular',
          letterSpacing: '0px',
          lineHeight: '140%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
      semibold: {
        value: {
          fontSize: '0.875rem',
          fontSizePx: '14px',
          fontFamily: 'Manrope',
          fontWeight: 'SemiBold',
          letterSpacing: '0px',
          lineHeight: '150%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
    },
    body_: {
      _large: {
        value: {
          fontSize: '1.125rem',
          fontSizePx: '18px',
          fontFamily: 'Manrope',
          fontWeight: 'SemiBold',
          letterSpacing: '0px',
          lineHeight: '140%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
    },
    display: {
      regular: {
        value: {
          fontSize: '4rem',
          fontSizePx: '64px',
          fontFamily: 'Manrope',
          fontWeight: 'Bold',
          letterSpacing: '-1px',
          lineHeight: '125%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
      small: {
        value: {
          fontSize: '2.5rem',
          fontSizePx: '40px',
          fontFamily: 'Manrope',
          fontWeight: 'Bold',
          letterSpacing: '-1px',
          lineHeight: '125%',
          textIndent: '0px',
          textTransform: 'none',
        },
      },
    },
  },
  fontFamily: {
    tech: '"Share Tech Mono"',
    poppins: 'Poppins',
    manrope: 'Manrope',
  },
  queries: QUERIES,
} as const

export default themeObj
